import { createContext } from 'react';

const GraphContext = createContext({
  // yAxisMinMax: {},
  // uniformYAxis: false,
  sensorDataRefresh: {}
});
export const GraphContextProvider = GraphContext.Provider;
export default GraphContext;
